import DialogModal from 'src/components/ui/dialogModal';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useState } from 'react';

const NO_ATTEMPT = 0;
const ATTEMPT_INCREMENT = 1;

export const RulePermissionDialog: React.FC<{ onClose: () => void }> = ({
    onClose,
}) => {
    const { t } = useTranslation();
    const text = (key: string, defaultValue: string) =>
        t(`SystemAdmin.RulePermissionModal.${key}`, { defaultValue });

    return (
        <DialogModal
            titleContent={text(
                'Title',
                'You do not have permission to continue',
            )}
            bodyContent={text(
                'Body',
                'Your user does not have permission to create, edit or delete distribution rules. Please contact your administrator to request the Distribution Rule Management permission.',
            )}
            open
            cancelBtnLabel={text('Close', 'Close')}
            confirmBtnLabel=''
            showConfirmButton={false}
            onCancelHandler={onClose}
            onConfirmHandler={onClose}
        />
    );
};

/**
 * The dialog remounts on every attempt so it reopens even if the browser
 * closed the native <dialog> (Escape) without notifying React.
 */
export const useRulePermissionDialog = () => {
    const [attempt, setAttempt] = useState(NO_ATTEMPT);

    const showNoPermissionDialog = useCallback(
        () => setAttempt((current) => current + ATTEMPT_INCREMENT),
        [],
    );
    const closeDialog = useCallback(() => setAttempt(NO_ATTEMPT), []);

    return {
        showNoPermissionDialog,
        noPermissionDialog:
            attempt > NO_ATTEMPT ? (
                <RulePermissionDialog key={attempt} onClose={closeDialog} />
            ) : null,
    };
};
